<template>
  <div id="Header">
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <img src="@/assets/Sistesi.png" contain style="height:38px; padding-top: 7px; cursor: pointer" @click="toHomeHandler()">
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="menubar">
        <v-btn icon @click="toHomeHandler()">
          <v-icon color="#212121">fas fa-home</v-icon>
        </v-btn>
        <v-menu
          bottom
          origin="center center"
          transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn v-if="langKey === 'id'" icon v-on="on">
              {{ langKey }}
            </v-btn>
            <v-btn v-else icon v-on="on">
              {{ langKey }}
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
              v-for="(lang, index) in langs"
              :key="index"
              @click="changeLangHandler(lang.id)"
            >
              <v-list-tile-title>{{ lang.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
  </div>
</template>

<script>
import router from '@/router';
import store from '@/stores';
import { setTimeout } from 'timers';

export default {
  data: () => ({
    openMenu: false,
    langs: [
      { id: 'id', name: 'ID' },
      { id: 'en', name: 'EN' },
    ],
  }),
  computed: {
    langKey() {
      return store.getters.langKey;
    },
  },
  methods: {
    toHomeHandler() {
      store.commit('isLoading', true);
      setTimeout(() => {
        store.commit('isLoading', false);
        router.push({ name: 'Home' });
        window.scrollTo(0, 0);
      }, 1000);
    },
    changeLangHandler(val) {
      if (this.langKey !== val) {
        store.commit('isLoading', true);
        store.dispatch('setLang', val);
        this.$i18n.locale = val;
      }
    },
  },
};
</script>
